export const BOOKING_PATIENT_NOTE_PARTS = [
  {
    key: "sleepStudyForm",
    label: "Sleep Study Form",
    normalizedTitle: "sleep study form",
    required: false,
  },
  {
    key: "consentForm",
    label: "Consent Form",
    normalizedTitle: "consent form",
    required: false,
  },
  {
    key: "opdCard",
    label: "OPD Card",
    normalizedTitle: "opd card",
    required: false,
  },
];

export const normalizeBookingPatientNoteTitle = (value) =>
  String(value || "")
    .normalize("NFKC")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

export const getBookingPatientNoteFileNames = (note = {}) => {
  if (Array.isArray(note.filename)) {
    return note.filename.map((fileName) => String(fileName || "").trim()).filter(Boolean);
  }

  const fileName = String(note.filename || "").trim();
  return fileName ? [fileName] : [];
};

export const getBookingPatientNoteChecklist = (
  notes = [],
  { hn = "" } = {},
) => {
  const patientHn = String(hn || "").trim();
  const normalizedNotes = (Array.isArray(notes) ? notes : [])
    .filter((note) => note && typeof note === "object")
    .map((note) => ({
      ...note,
      normalizedTitle: normalizeBookingPatientNoteTitle(note.title),
    }));

  const parts = BOOKING_PATIENT_NOTE_PARTS.map((part) => {
    const matchingNotes = normalizedNotes.filter(
      (note) => note.normalizedTitle === part.normalizedTitle,
    );
    const files = matchingNotes.reduce(
      (noteFiles, note) => [
        ...noteFiles,
        ...getBookingPatientNoteFileNames(note).map((fileName) => ({
          id: note.id,
          hn: String(note.hn || patientHn).trim(),
          fileName,
          title: part.label,
        })),
      ],
      [],
    );

    return {
      ...part,
      notes: matchingNotes,
      files,
      hasNote: matchingNotes.length > 0,
      hasFile: files.length > 0,
    };
  });
  const missingParts = parts.filter(
    (part) => part.required && !part.hasFile,
  );

  return {
    parts,
    missingParts,
    isReady: missingParts.length === 0,
  };
};

export const getBookingDoctorPatientNoteFiles = (notes = [], { hn = "" } = {}) =>
  getBookingPatientNoteChecklist(notes, { hn }).parts
    .filter((part) => ["sleepStudyForm", "opdCard"].includes(part.key))
    .reduce((files, part) => [...files, ...part.files], []);
